
import { MaterialConfiguration } from 'app/core/components/workflow-new/material/configurations/material-configuration';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
export class GoogleSlidesCardConfiguration extends MaterialConfiguration {
    constructor(course: any) {
        super();
        this.tagType = 'material';
        this.thumbnail = course.smallImageUri || 'https://itpx-branded-portal-dev.s3.amazonaws.com/presentation.png';
        this.classType = 'Google Slides';
        this.subtitle = 'branded.portal.courses.assignment.material.googleslides.subtitle';
        this.expired = !course.enabled;
        this.multiContent = course.contents.length > 1;
        this.clickable = !this.expired;
        this.target = ['googleslides', course.contents[0].id];
        this.action = LinkActions.REDIRECT;
        this.links = [{
            disabled: this.expired,
            tooltip: this.expired ? 'branded.portal.courses.assignment.material.googleslides.expired.tooltip' : null,
            url: !this.expired ? ['googleslides', course.contents[0].id] : [],
            text: 'branded.portal.courses.assignment.googleslides.view.text',
            type: LinkActions.REDIRECT,
            // image: this.expired ? 'https://itpx-branded-portal-dev.s3.amazonaws.com/download-inactive.svg' :
                // 'https://itpx-branded-portal-dev.s3.amazonaws.com/download.svg'
        }]
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/configurations/google-slides-card-configuration.ts